import { modelPool, useExternalMessages } from "@modules/model";
const CONTROLLER_GRIP_SPACE_MODEL_SUFFIX = "_grip_space";
export function getControllerGripSpaceModelName(controllerModelName) {
    return `${controllerModelName}${CONTROLLER_GRIP_SPACE_MODEL_SUFFIX}`;
}
export function ensureControllerGripSpaceModel(controllerModel, meshInfo, pendingMessages) {
    var _a;
    const gripSpaceName = getControllerGripSpaceModelName(controllerModel.getName());
    const gripSpaceModel = (_a = controllerModel.getChild(gripSpaceName)) !== null && _a !== void 0 ? _a : modelPool.createModel(gripSpaceName, controllerModel, pendingMessages !== undefined ? useExternalMessages(pendingMessages) : undefined);
    gripSpaceModel.setTransformComponents(meshInfo.gripSpace.position, meshInfo.gripSpace.orientation, meshInfo.gripSpace.scale, pendingMessages !== undefined ? useExternalMessages(pendingMessages) : undefined);
    return gripSpaceModel;
}
export function getControllerGripSpaceModel(controllerUid) {
    const controllerModel = modelPool.getModel(controllerUid);
    if (controllerModel === undefined)
        return undefined;
    return controllerModel.getChild(getControllerGripSpaceModelName(controllerModel.getName()));
}
export function getControllerPickupTargetUid(controllerUid) {
    var _a, _b;
    return (_b = (_a = getControllerGripSpaceModel(controllerUid)) === null || _a === void 0 ? void 0 : _a.getUID()) !== null && _b !== void 0 ? _b : controllerUid;
}
